import { createFileRoute } from "@tanstack/react-router";
import FathersDayGifts from "@/pages/FathersDayGifts";

export const Route = createFileRoute("/gifts/fathers-day")({
  component: FathersDayGifts,
});
